import { render } from "./VitalDetail.vue?vue&type=template&id=853b6178&ts=true"
import script from "./VitalDetail.vue?vue&type=script&lang=ts"
export * from "./VitalDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__